import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import SimproIntegrationConfiguration from 'components/projects/simproIntegrationConfiguration/components/SimproIntegrationConfiguration';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <SimproIntegrationConfiguration {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
